import React, { useState } from 'react';
import { Form, Field } from 'react-final-form';
import { Button, Input } from 'antd';
import { SelectOptionsSubjectInterface } from 'interface/general';
import ModalCustomMaterial from 'materials/ModalCustomMaterial';

type Props = {
  isShow: boolean;
  onCancel: () => void;
  onSave: () => void;
  dataSubjectList: SelectOptionsSubjectInterface[];
  subjectValue: string;
  setSubjectValue: (value: string) => void;
  setSubjectId: (id: number) => void;
  handleDelete: (id: number) => void;
};

export default function ModalAddSubjectComponent({
  isShow,
  onCancel,
  onSave,
  dataSubjectList,
  subjectValue,
  handleDelete,
  setSubjectValue,
  setSubjectId,
}: Props) {
  const [editingId, setEditingId] = useState<number | null>(null);
  const [editedValues, setEditedValues] = useState<Record<number, string>>({});
  const [inputValue, setInputValue] = useState('');

  return (
    <ModalCustomMaterial
      teksTitle="LIST SUBJEK"
      visible={isShow}
      width="40%"
      onCancel={onCancel}
      content={
        <Form
          onSubmit={({ newSubject }) => {
            setSubjectValue(newSubject);
            onSave();
          }}
          initialValues={{ newSubject: '' }}
          validate={values => {
            const errors: any = {};
            if (!values.newSubject) {
              errors.newSubject = 'Nama Subjek wajib diisi';
            } else if (values.newSubject.length > 100) {
              errors.newSubject = 'Maksimal 100 karakter';
            }
            return errors;
          }}
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div style={{ padding: 16 }}>
                {/* Input + Button */}
                <div
                  style={{
                    display: 'flex',
                    gap: 8,
                    // alignItems: 'center',
                    marginBottom: 16,
                  }}
                >
                  <Field name="newSubject">
                    {({ input, meta }) => (
                      <div style={{ flexGrow: 1 }}>
                        <Input
                          {...input}
                          placeholder="Tulis Nama Subjek"
                          style={{ height: 32 }}
                          maxLength={100}
                          onChange={e => {
                            input.onChange(e);
                            setInputValue(e.target.value);
                          }}
                        />
                        {meta.touched && meta.error && (
                          <div style={{ color: 'red', fontSize: 12 }}>
                            {meta.error}
                          </div>
                        )}
                      </div>
                    )}
                  </Field>

                  <button
                    type="submit"
                    disabled={inputValue.trim() === ''}
                    style={{
                      background:
                        inputValue.trim() === '' ? '#EEEEEE' : 'white',
                      border:
                        inputValue.trim() === ''
                          ? '1px solid #bfbfbf'
                          : '1px solid #11BEFF',
                      color: inputValue.trim() === '' ? '#bfbfbf' : '#11BEFF',
                      borderRadius: 8,
                      padding: '0 12px',
                      height: 32,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor:
                        inputValue.trim() === '' ? 'not-allowed' : 'pointer',
                    }}
                  >
                    <span
                      style={{
                        background:
                          inputValue.trim() === '' ? '#bfbfbf' : '#11BEFF',
                        color: inputValue.trim() === '' ? '#EEEEEE' : 'white',
                        borderRadius: '50%',
                        width: 18,
                        height: 18,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        fontSize: 16,
                        lineHeight: 1,
                        paddingBottom: 2,
                      }}
                    >
                      +
                    </span>
                  </button>
                </div>

                {/* Subject List */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12,
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      height: '2px',
                      backgroundImage: `repeating-linear-gradient(
                        to right,
                        #11BEFF,
                        #11BEFF 16px,
                        transparent 16px,
                        transparent 25px
                      )`,
                      margin: '16px 0',
                    }}
                  />
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 12,
                      maxHeight: 300,
                      overflowY: 'auto',
                      paddingRight: 4,
                    }}
                  >
                    {dataSubjectList.map((subject, index) => {
                      const isEditing = editingId === Number(subject.id);
                      return (
                        <div
                          key={index}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <Input
                            value={
                              isEditing
                                ? editedValues[subject.id]
                                : subject.subject
                            }
                            onChange={e =>
                              setEditedValues({
                                ...editedValues,
                                [subject.id]: e.target.value,
                              })
                            }
                            disabled={!isEditing}
                            style={{
                              flex: 1,
                              marginRight: 40,
                              backgroundColor: isEditing ? '#fff' : '#eee',
                              height: '100%',
                              paddingTop: 8,
                              paddingBottom: 8,
                            }}
                          />

                          <div style={{ display: 'flex', gap: 12 }}>
                            {isEditing ? (
                              <div
                                style={{
                                  padding: '6px 16px',
                                  border: '1px solid #FFE600',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  setSubjectValue(editedValues[subject.id]);
                                  setSubjectId(Number(subject.id));
                                  onSave();
                                  setEditingId(null);
                                }}
                              >
                                <Button
                                  icon="edit"
                                  size="small"
                                  type="primary"
                                  style={{
                                    background: '#FFE600',
                                    borderRadius: 50,
                                    borderColor: '#FFE600',
                                  }}
                                />
                              </div>
                            ) : (
                              <div
                                style={{
                                  padding: '6px 16px',
                                  border: '1px solid #FFE600',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  setEditingId(Number(subject.id));
                                  setEditedValues({
                                    ...editedValues,
                                    [subject.id]: subject.subject,
                                  });
                                }}
                              >
                                <Button
                                  icon="edit"
                                  size="small"
                                  type="primary"
                                  style={{
                                    background: '#FFE600',
                                    borderRadius: 50,
                                    borderColor: '#FFE600',
                                  }}
                                />
                              </div>
                            )}
                            <div
                              style={{
                                padding: '6px 16px',
                                border: '1px solid #ff4d4f',
                                borderRadius: '6px',
                                cursor: 'pointer',
                              }}
                              onClick={() => handleDelete(Number(subject.id))}
                            >
                              <Button
                                icon="delete"
                                size="small"
                                type="primary"
                                style={{
                                  background: '#ff4d4f',
                                  borderRadius: 50,
                                  borderColor: '#ff4d4f',
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </form>
          )}
        </Form>
      }
    />
  );
}
